import React from 'react';


export class Terms extends React.Component{
    render(){
        return(
            <div>
            <h2>Tietosuojaseloste</h2>

<p>
1	Yleistä
</p>
<p>
Tällä selosteella kerromme Pohjola Terveys Oy:n suorittamasta henkilötietojen käsittelystä sidosryhmien yhteydenpitoon liittyen. Sidosryhmätoimintaan liittyvä tietojenkäsittely on osa Pohjola Terveys Oy:n tietojenkäsittelyn kokonaisuutta, josta kerromme muilta osin osoitteessa <a href="https://www.pohjolasairaala.fi/fi/tietoa-meista/tietosuojaseloste" target="_blank">https://www.pohjolasairaala.fi/fi/tietoa-meista/tietosuojaseloste</a>
</p>
<p>Tällä tietosuojaselosteella annetaan EU:n yleisen tietosuoja-asetuksen (jäljempänä tietosuoja-asetus) sekä kansallisen lainsäädännön edellyttämiä tietoja yhtäältä rekisteröidylle ja toisaalta valvovalle viranomaiselle.
</p>
<p>2	Rekisterinpitäjä ja rekisterinpitäjän yhteystiedot
</p>
<p>Pohjola Terveys Oy<br />
Osoite: Puutarhurinkuja 2, 00300 HELSINKI<br />
Rekisterinpitäjän yhteyshenkilö: Nina Vesaniemi<br />
Puhelinnumero: vaihde 010 257 8100<br />
Sähköpostiosoite: palautelomake osoitteessa <a href="https://www.pohjolasairaala.fi/fi/tietoa-meista/palaute" target="_blank">https://www.pohjolasairaala.fi/fi/tietoa-meista/palaute</a><br />

Tietosuojavastaava: tietosuojavastaava@pohjolaterveys.fi
</p>
<p>
3	Henkilötietojen käsittelyn tarkoitukset ja käsittelyn oikeusperuste
</p>
<p>Henkilötietojen käyttötarkoitukset sidosryhmätoiminnassa ovat:<br />
-	Yhteydenpito sidosryhmien edustajiin<br />
-	Rekrytointi<br />
-	Viestintä ja suoramarkkinointi<br />
-	Markkinoinnin ja mainonnan kohdentaminen
</p>
<p>
		Henkilötietoja käsitellään henkilön suostumuksen tai oikeutetun edun perusteella.
</p>
<p>
4	Käyttötarkoituksen mukaiset henkilötietoryhmät ja tietosisältö
</p>
<p>Sidosryhmätoimintaan liittyvissä käyttötarkoituksissa käsitellään seuraavia henkilötietoryhmiä:
</p>
<p>Perustiedot<br />
-	Nimi<br />
-	Yhteystiedot<br />
-	Ammatti ja ammatillinen pätevyys<br />
-	Paikkakunta<br />
-	Muut henkilöä kuvaavat, esim. kiinnostuksen kohteita ilmentävät tiedot<br />
-	Henkilön kanssa käytyyn yhteydenpitoon liittyvät tiedot
</p>
<p>
Suostumukset
-	Henkilötietojen käsittelyä ja luovutuksia koskevat suostumukset ja kiellot
</p>
<p>	
5	Henkilötietojen vastaanottajat ja vastaanottajaryhmät
</p>
<p>
Henkilötietoja ei pääsääntöisesti luovuteta. Jos luovutuksia jossain yksittäistapauksessa tehdään, se perustuu joko rekisteröidyn suostumukseen, oikeutettuun etuun tai luovuttamisen mahdollistavaan lainsäännökseen. 
</p>
<p>
Rekisteröidyllä on milloin tahansa oikeus muuttaa antamiaan suostumuksia tai kieltoja koskien tietojensa luovutusta. 
</p>
<p>
Henkilötietojen siirtäminen
</p>
<p>
Rekisterinpitäjä käyttää alihankkijoita tietojen käsittelyssä, mutta tietoja ei siirretä EU:n tai ETA:n ulkopuolelle.
</p>
<p>
6	Henkilötietojen säilytysaika tai säilytysajan määrittämiskriteerit
</p>
<p>
Henkilötiedot poistetaan, kun niitä ei enää tarvita niihin tarkoituksiin, joita varten ne kerättiin tai joita varten niitä muutoin käsiteltiin.
</p>
<p>
7	Henkilötietojen lähteet ja päivittäminen
</p>
<p>
Henkilötietoja kerätään rekisteröidyltä itseltään sekä hänen kanssaan käytyyn yhteydenpitoon liittyen.
</p>
<p>
8	Rekisteröidyn oikeudet
</p>
<p>
Rekisteröidyllä on oikeus saada rekisterinpitäjän vahvistus siitä, käsitelläänkö rekisteröidyn henkilötietoja vai ei tai onko niitä käsitelty.<br />
Mikäli rekisterinpitäjä käsittelee rekisteröidyn henkilötietoja, rekisteröidyllä on pääsääntöisesti oikeus saada tarkastaa tietonsa. <br />
Rekisterinpitäjä voi periä kohtuullisen hallinnollisen maksun rekisteröidyn pyytämistä lisäjäljennöskappaleista. Mikäli rekisteröity tekee pyynnön sähköisesti, eikä hän ole pyytänyt muuta toimitusmuotoa, tiedot toimitetaan yleisesti käytössä olevassa sähköisessä muodossa edellyttäen, että tiedot voidaan toimittaa tietoturvallisella tavalla.<br />
Rekisteröidyllä on myös oikeus pyytää rekisterinpitäjää oikaisemaan tai poistamaan henkilötietojaan ja hän voi vastustaa henkilötietojensa käsittelyä markkinointiin, mikäli tietoja käytetään tässä käyttötarkoituksessa.<br />
Rekisteröidyllä on myös tietyissä tilanteissa oikeus pyytää henkilötietojensa käsittelyn rajoittamista tai muuten vastustaa käsittelyä. Lisäksi rekisteröidyllä on tietyissä tilanteissa oikeus siirtää muuta kuin potilastietoa koneluettavassa muodossa esimerkiksi itselleen.<br />
Rekisteröity voi esittää oikeuksiaan koskevat pyynnöt suoraan Pohjola Terveys Oy:n asiakaspalveluun.<br />
Mikäli rekisteröity katsoo, ettei hänen henkilötietojensa käsittely ole lainmukaista, hänellä on oikeus tehdä asiassa valitus valvontaviranomaiselle.
</p>
<p>
9	Oikeus peruuttaa suostumus
</p>
<p>
Mikäli rekisterinpitäjä käsittelee rekisteröidyn henkilötietoja suostumuksen perusteella, rekisteröidyllä on oikeus peruuttaa suostumuksensa milloin tahansa. Suostumuksen peruuttaminen voi kuitenkin vaikuttaa palvelujen käytettävyyteen ja toiminnallisuuksiin.
</p>
<p>10	Miten rekisterin suojaus on järjestetty
    </p>
<p>
Rekisterinpitäjä on suojannut tiedot asianmukaisesti teknisesti ja organisatorisesti. Rekisterin suojauksessa käytetään mm. seuraavia keinoja:<br />
-	laitteistojen ja tiedostojen suojaus<br />
-	kulunvalvonta<br />
-	käyttäjien tunnistus<br />
-	käyttövaltuudet<br />
-	käyttötapahtumien rekisteröinti<br />
-	käsittelyn ohjeistus ja valvonta
</p>
<p>
Rekisterinpitäjä edellyttää myös alihankkijoiltaan käsiteltävien henkilötietojen asianmukaista suojaamista.
</p>

        </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Terms.js